import { Link, useRouterState } from "@tanstack/react-router";
import { ChartIcon, InstagramIcon } from "@signet/ui";
import { useMe } from "@signet/web-kit";

/* Posting and Analytics, the two Main Accounts pages. Analytics is about
   Auto-Downloads, so someone who can't see those gets no tabs at all and the
   page looks as it always did. */

export function MainAccountsTabs() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const { can } = useMe();
  if (!can("mainaccounts.download:view")) return null;
  const tab = pathname.startsWith("/main-accounts/analytics") ? "analytics" : "posting";
  const on = (name: string) => ({ className: tab === name ? "on" : "", "aria-current": tab === name ? ("page" as const) : undefined });
  return (
    <nav className="ma-tabs" aria-label="Main Accounts">
      {/* Module routes are not in the router's typed path list, hence the casts. */}
      <Link to={"/main-accounts" as never} {...on("posting")}>
        <InstagramIcon size={13} />
        Posting
      </Link>
      <Link to={"/main-accounts/analytics" as never} {...on("analytics")}>
        <ChartIcon size={13} />
        Analytics
      </Link>
    </nav>
  );
}
